/* ------------------------------------------------------------------
   Frantic - Add to Cart: Klick-Impact
   1. Entfernt den grauen Klick-/Tap-Schleier auf und um den Button
   2. Kurzer Impact beim Druecken: Button federt rein und wieder raus
   Kein Overlay, kein Haekchen, kein Label, kein Delay.
   Eigenstaendige Datei - geladen ueber snippets/head-preloader.liquid
------------------------------------------------------------------ */
(function () {
  if (window.__franticATC) { return; }
  window.__franticATC = true;

  var BTN_SEL = '[data-js-product-add-to-cart],[data-js-atc]';

  /* ---------- CSS ---------- */

  var CSS = [
    /* Fix: grauer Tap-/Klick-Schleier auf und um den Button */
    '.add-to-cart,.add-to-cart *,[data-js-atc],[data-js-atc] *,',
    '.quantity-selector-holder,.quantity-selector-holder *,',
    '.product__cart-functions .shopify-payment-button__button',
    '{-webkit-tap-highlight-color:transparent;-webkit-touch-callout:none}',

    '.add-to-cart,[data-js-atc]{-webkit-user-select:none;user-select:none}',
    '.add-to-cart img,[data-js-atc] img{-webkit-user-drag:none;pointer-events:none}',

    /* FRANTIC 2026-08 (Barrierefreiheit):
       Hier wurden zuvor :focus UND :focus-visible mitunterdrueckt. Zusammen mit
       dem Inline-Style am Button (outline:none !important) blieb damit fuer
       Tastaturnutzer gar kein sichtbarer Fokus uebrig - am wichtigsten
       Bedienelement der Seite. :active bleibt unterdrueckt, damit der
       Klick-Effekt unveraendert aussieht. */
    '.add-to-cart:not(.disabled):active,',
    '[data-js-atc]:not(.disabled):active',
    '{filter:none;box-shadow:none !important;outline:none}',

    /* FRANTIC 2026-08 (Bugfix): der Ring sass via :focus-within am
       umschliessenden .flex-buttons. Zwei Probleme:

       1. :focus-within unterscheidet NICHT zwischen Maus und Tastatur. Jeder
          Mausklick auf den Kaufen-Button loeste den Rahmen aus - und wenn der
          Warenkorb-Drawer sich schloss, gab er den Fokus an den Button zurueck
          (section-header.js), wodurch der Rahmen erneut erschien.
       2. sections/ss-payment-icons.liquid haengt seine Icon-Liste per
          insertAdjacentHTML('afterend') an den erstbesten Treffer - das ist
          der Kaufen-Button. Die Liste landet damit INNERHALB von .flex-buttons,
          und der Rahmen umschloss Button UND Zahlungsicons.

       Der Ring sitzt jetzt direkt am Button und nur noch bei :focus-visible,
       also ausschliesslich bei Tastaturbedienung. */
    '.add-to-cart:not(.disabled):has(:focus-visible)',
    '{outline:3px solid currentColor;outline-offset:3px;border-radius:2px}',
    '.product__cart-functions .flex-buttons:focus-within',
    '{outline:0}',
    '@supports not selector(:has(*)){',
    '.add-to-cart:not(.disabled):focus-visible',
    '{outline:3px solid currentColor !important;outline-offset:3px}}',

    /* Impact */
    '.frantic-atc.frantic-impact',
    '{animation:franticImpact 320ms cubic-bezier(.33,.9,.4,1) forwards}',
    '@keyframes franticImpact{',
    '0%{transform:scale(1)}',
    '26%{transform:scale(.953)}',
    '58%{transform:scale(1.014)}',
    '100%{transform:scale(1)}}',

    '@media (prefers-reduced-motion:reduce){',
    '.frantic-atc.frantic-impact{animation-duration:1ms !important}}'
  ].join('');

  var styleTag = document.createElement('style');
  styleTag.id = 'frantic-atc-style';
  styleTag.textContent = CSS;
  (document.head || document.documentElement).appendChild(styleTag);

  /* ---------- Button vorbereiten ---------- */

  function prepare(btn) {
    if (!btn || btn.getAttribute('data-frantic-ready') === '1') { return; }
    btn.setAttribute('data-frantic-ready', '1');

    /* alte Inline-Handler entfernen - sie setzen dauerhaft opacity:1
       und blockieren jede Bewegung */
    btn.removeAttribute('onmousedown');
    btn.removeAttribute('onmouseup');
    btn.onmousedown = null;
    btn.onmouseup = null;
    /* transition/Inline-Styles des Themes bleiben unangetastet -
       der Impact laeuft als CSS-Animation, nicht als Transition */
    btn.classList.add('frantic-atc');
  }

  function impact(btn) {
    btn.classList.remove('frantic-impact');
    void btn.offsetWidth;
    btn.classList.add('frantic-impact');
    window.setTimeout(function () { btn.classList.remove('frantic-impact'); }, 340);
  }

  /* ---------- Druck erkennen ---------- */

  function onPress(e) {
    var btn = e.target && e.target.closest ? e.target.closest(BTN_SEL) : null;
    if (!btn || btn.classList.contains('disabled')) { return; }
    prepare(btn);
    impact(btn);
  }

  if (window.PointerEvent) {
    document.addEventListener('pointerdown', onPress, true);
  } else {
    document.addEventListener('mousedown', onPress, true);
    document.addEventListener('touchstart', onPress, true);
  }

  /* ---------- Init ---------- */

  function init() {
    var nodes = document.querySelectorAll(BTN_SEL);
    for (var i = 0; i < nodes.length; i++) { prepare(nodes[i]); }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
  window.addEventListener('load', init);
})();
